/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { of, Subject } from 'rxjs';
import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DistributorSupportService } from '../services/distributorSupport.service';
import { GenealogyService } from '../services/genealogy.service';
import { Router } from '@angular/router';
import { debounceTime, flatMap } from 'rxjs/operators';
import { delay } from 'rxjs/operators';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-organization-search',
  templateUrl: './organization-search.component.html',
  styleUrls: ['./organization-search.component.scss']
})
export class OrganizationSearchComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Output() organizationSelected: EventEmitter<any> = new EventEmitter();
  @Output() clearSelectedFilter: EventEmitter<any> = new EventEmitter();
  @Output() closeSearchComponent: EventEmitter<any> = new EventEmitter();
  @Input() selectedOrganization: any = null;
  @Input() defaultFilterValue: any;
  @Input() isFrom: any;
  @Input() periodName: any;
  @Input() disabledField: any = false;
  @Input() searchHeader: any;
  @Input() showSearchBar = true;
  @Input() showSelectedOrganization = true;
  @Input() displayPlanName = true;
  @Input() noOrganizationMsg = '';
  @Input() noMarginLeft = false;
  public globalFilterValue = '';
  public organizationData: any = [];
  public listOfOrganizations: any = [];
  private searchTerms = new Subject<any>();
  public isDataFiltered = false;
  public filterBy: any = { group: '3', isHomeMarket: false };
  
  constructor(
    private router: Router,
    private distributorSupportService: DistributorSupportService,
    private genealogyService: GenealogyService,
    private toastr: ToastrService,
    public commonService: CommonService
  ) {}

  ngOnInit() {
    this.searchTerms
      .pipe(
        debounceTime(500),
        flatMap((search) => of(search).pipe(delay(100)))
      )
      .subscribe(this.filterData.bind(this));
  }

  ngAfterViewInit(): void {
    const globalSearchInput = document.getElementById('globalSearchInputTag');
    if (globalSearchInput) {
      globalSearchInput.focus();
    }
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }


  ngOnChanges(changes: any) {    
    if (changes.defaultFilterValue && changes.defaultFilterValue.currentValue) {
      this.globalFilterValue = changes.defaultFilterValue.currentValue;
      this.globalFilterValue = this.globalFilterValue.trim();
      if (!this.globalFilterValue) {
        this.clearFilter();
      }
    }
  }

  private getListOfOrganizations() {
    let searchText = this.globalFilterValue || '';
    const hideLoader = this.isFrom === 'sidebar' ? true : false;
    searchText = searchText.trim();    
    if (searchText) {
      this.distributorSupportService
        .filterGlobalOrganizationValue(searchText, false, undefined, undefined, hideLoader, this.periodName)
        .then(this.getOrganizationsSH.bind(this), this.getOrganizationsFH.bind(this));
    }
  }

  private getOrganizationsSH(data: any) {
    const organizationList = data ? data.data : [],
    finalOrganizationList: any = [];  
    if (organizationList && organizationList.length) {
      organizationList.forEach((item: any) => {
        const orgListObj: any = item;
        orgListObj.name = (item.firstName || '') + ' ' + (item.lastName || '');
        finalOrganizationList.push(orgListObj);
    });
    }
    this.organizationData = finalOrganizationList;
    this.isDataFiltered = true;
  }

  private getOrganizationsFH(err: any) {
    const error = JSON.parse(err);
    let altLbl = '';
    if (error.errors && error.errors.message) {
      altLbl = error.errors.message;
    } else if (error.message) {
      altLbl = error.message;
    } else {
      altLbl = 'Unknown Problem';
    }
    this.toastr.error(altLbl, this.getTranslationWithKey('error'),{ enableHtml: true });
  }

  private abbrName(strings: any, fNameExp: any, lNameExp: any) {
    let str = '';
    if (fNameExp) {
      str += fNameExp.substring(0, 1);
    }
    if (lNameExp) {
      str += lNameExp.substring(0, 1);
    }

    return str.toUpperCase();
  }

  public getAbbrName(selectedOrganization: any) {
    const str = this.abbrName`${selectedOrganization.orgUnitName}${selectedOrganization.lastName || ''}`; /* Template Strings */
    return str;
  }

  public search(term: string): void {
    this.isDataFiltered = false;
    if (term) {
      this.searchTerms.next(term);
    } else {
      this.clearFilter();
    }
  }

  public filterData() {
    if (this.globalFilterValue.length >= 1) {
      this.getListOfOrganizations();
    }
  }

  public clearFilter() {
    if (!this.disabledField) {
      this.globalFilterValue = '';
      this.organizationData = '';
      this.selectedOrganization = null;
      this.isDataFiltered = false;
      if (this.clearSelectedFilter) {
        this.clearSelectedFilter.emit();
      }
    }
  }

  public selectSpecificOrganization(organization: any) {
    this.selectedOrganization = organization;
    this.globalFilterValue = organization?.clientId;
    this.organizationData = [];
    this.isDataFiltered = false;
    if (this.organizationSelected) {
      this.organizationSelected.emit(organization);
    }
  }

  public closeSearch() {
    this.closeSearchComponent.emit(false);
  }

  ngOnDestroy() {
    this.globalFilterValue = '';
    this.searchTerms.unsubscribe();
  }
}
